import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'
// import eventBus from './utils/eventBus/index'
// import HttpClient from './api/index'
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import '@arco-design/web-vue/dist/arco.css';
import ZH_CN from 'element-plus/es/locale/lang/zh-cn';
import "./assets/css/index.css";

const pinia = createPinia()
pinia.use(piniaPersist)

const app = createApp(App)
app.use(ElementPlus,{ locale: ZH_CN })
app.use(pinia)
app.use(router)
app.use(ArcoVueIcon)
// app.use(eventBus)
// app.use(HttpClient)
app.mount('#app')
